module.exports = __webpack_public_path__ + "assets/img/front.1a1c4324.png";